import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getAccessoriesCombos = () => apiActionCreator({
  'endpoint': '/accessories/combos',
  'authenticated': true,
  'types': [
    ActionTypes.GETTING_ACCESSORIES_COMBOS,
    ActionTypes.GOTTEN_ACCESSORIES_COMBOS,
    [
      ActionTypes.GOTTEN_ACCESSORIES_COMBOS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getComboTasks = (combo) => apiActionCreator({
  'endpoint': `/accessories/combos/${combo}/tasks`,
  'authenticated': true,
  'types': [
    ActionTypes.GETTING_COMBO_TASKS,
    ActionTypes.GOTTEN_COMBO_TASKS,
    [
      ActionTypes.GOTTEN_COMBO_TASKS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getCombosCandidateTasks = (combo) => apiActionCreator({
  'endpoint': `/accessories/combos/${combo}/candidateTasks`,
  'authenticated': true,
  'types': [
    ActionTypes.GETTING_COMBO_CANDIDATE_TASKS,
    ActionTypes.GOTTEN_COMBO_CANDIDATE_TASKS,
    [
      ActionTypes.GOTTEN_COMBO_CANDIDATE_TASKS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const assignComboTask = (index, combo, taskData) => apiActionCreator({
  'endpoint': `/accessories/combos/${combo}/tasks`,
  'authenticated': true,
  'types': [
    ActionTypes.ASSIGNING_COMBO_TASK,
    {'type': ActionTypes.ASSIGNED_COMBO_TASK, 'payload': index},
    [
      ActionTypes.ASSIGNED_COMBO_TASK_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': taskData,
});

export const deleteComboTask = (index, combo, taskData) => apiActionCreator({
  'endpoint': `/accessories/combos/${combo}/tasks`,
  'authenticated': true,
  'types': [
    ActionTypes.DELETING_COMBO_TASK,
    [
      {'type': ActionTypes.DELETED_COMBO_TASK, 'payload': {index, taskData}},
      MessageActions.addMessageBoxInfo('Tarea eliminada satisfactoriamente'),
    ],
    [
      ActionTypes.DELETED_COMBO_TASK_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
  'contentType': 'application/json',
  'data': taskData,
});

export const clearComboTasksPage = () => ({
  'type': ActionTypes.CLEAR_COMBO_TASKS_PAGE,
});

export const addComboTask = () => ({
  'type': ActionTypes.ADD_COMBO_TASK,
});

export const removeComboTask = (index) => ({
  'type': ActionTypes.REMOVE_COMBO_TASK,
  'payload': index,
});

export const selectCombo = (combo) => ({
  'type': ActionTypes.SELECT_COMBO,
  'payload': combo,
});

export const selectComboTask = (taskIndex) => ({
  'type': ActionTypes.SELECT_COMBO_TASK,
  'payload': taskIndex,
});
